import { useRef, ReactNode } from "react";
import { useFormData } from "@/components/forms/store/useFormData";
import { useFormState } from "@/components/forms/store/useFormState";
import { FormStoresContext } from "@/components/forms/context/formStoresContext";

interface FormContextProviderProps {
	id?: string;
	children: ReactNode;
}

export const FormContextProvider = ({ id = "default", children }: FormContextProviderProps) => {
	// Create unique store instances for each form using the ID
	const formDataStoreRef = useRef(useFormData());
	const formStateStoreRef = useRef(useFormState());

	return (
		<FormStoresContext.Provider
			value={{
				formDataStore: formDataStoreRef.current,
				formStateStore: formStateStoreRef.current,
			}}
		>
			{children}
		</FormStoresContext.Provider>
	);
};
